import { AxpKit } from '@axons-library/portal-js-sdk'
import {
  REACT_APP_AXONS_ONE_APP_ID,
  REACT_APP_AXONS_ONE_TENANT,
  REACT_APP_BASE_API_URL_AXONS_CLOUD,
} from 'config/env'

let axonsOneSdk = null

export const getAxonsOneSdk = () => {
  if (axonsOneSdk) {
    return axonsOneSdk
  }

  axonsOneSdk = AxpKit.load(REACT_APP_AXONS_ONE_APP_ID, {
    baseUrl: REACT_APP_BASE_API_URL_AXONS_CLOUD,
    storage: 'localStorage',
    defaultTenant: REACT_APP_AXONS_ONE_TENANT || 'cpf',
  })

  return axonsOneSdk
}
